/**
 * PHP 7.4 的类型转换语义（后端是 PHP 7.4，前端要与它逐字同义地读同一份配置时用）。
 * 以前放在 utils/surchargeRate.js 里，配送费（utils/deliveryFee.js）也要用，挪到这里共用
 * （券的 utils/couponDiscount.js 也用过，2026-09-29 Option A 收口随券的计算退回热修前删掉）。
 */

/** PHP 7.4 `(bool)$v`：false / null / 0 / 0.0 / "" / "0" / 空数组（JSON 的 [] 和 {}）为假，其余为真（含 "false"、"0.0"）。 */
export function phpTruthy(v) {
  if (v === null || v === undefined || v === false) return false
  if (typeof v === 'number') return v !== 0 && !Number.isNaN(v)
  if (typeof v === 'string') return v !== '' && v !== '0'
  if (Array.isArray(v)) return v.length > 0
  if (typeof v === 'object') return Object.keys(v).length > 0
  return true
}

// PHP 7.4 字符串转数字只认开头那一段十进制数（允许前导空白、正负号、小数、指数），后面是什么都不管。
const PHP_NUMERIC_PREFIX = /^[ \t\n\r\v\f]*[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?/

/** PHP 7.4 `(float)$v`。例："2.5" → 2.5，" 2.5" → 2.5，"2.5%" → 2.5，"abc" / "" / null → 0，true → 1。 */
export function phpFloat(v) {
  if (typeof v === 'number') return Number.isNaN(v) ? 0 : v
  if (typeof v === 'boolean') return v ? 1 : 0
  if (typeof v === 'string') {
    const m = PHP_NUMERIC_PREFIX.exec(v)
    return m ? Number(m[0].trim()) : 0
  }
  if (Array.isArray(v)) return v.length > 0 ? 1 : 0
  if (v && typeof v === 'object') return Object.keys(v).length > 0 ? 1 : 0
  return 0
}
